import { Accepts, Types } from "@citychallenge/common";
import { TransTokens } from "../../../i18n";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ReviewRequestProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.String) public title?: Types["String"];
  @Inlet(Accepts.MarkdownString) public subtitle?: Types["MarkdownString"];

  @Inlet(Accepts.Void) public logic?: Types["Void"];
}

export const ReviewRequestDefinition = defineElement(
  "review-request",
  ReviewRequestProps,
  {
    versionRequired: "0.24.0",
  }
);

export const reviewRequestTokens = TransTokens.create({
  title: "Congratulations!",
  subtitle: "You finished this story.",
  rate: "How was your experience?",
  share: "Want to share something about\n your experience?",
  placeholder: "Add your review here...",
  requestRating: "Don't forget to give a rating",
  vote: "vote",
  votes: "votes",
});
